import { findIndex } from "lodash";
import React from "react";

import Input from "./Input";

const allowedTypes = ["text", "textarea"];

const ReadOnlyInput = (props) => {
  if (props.type && findIndex(allowedTypes, (it) => it === props.type) === -1) {
    throw new Error(
      "Error! This component can only be of types: " + allowedTypes
    );
  }
  return <Input type="text" {...props} disabled />;
  // the order of these props are important, dot not change it (unless you really know what you are doing)
};

export default ReadOnlyInput;
